const PcbSpecValidations = {
  pcb_spec_properties: {
    layers: [
      { required: true, message: 'Layers cannot be empty!', trigger: 'change', type: 'integer' }
    ],
    width: [
      { required: true, message: 'Width cannot be empty!', trigger: 'change' }
    ],
    height: [
      { required: true, message: 'Height is required!', trigger: 'change' }
    ],
    material_details: [
      { required: true, message: 'Material cannot be empty!', trigger: 'change' }
    ],
    finish_thickness: [
      { required: true, message: 'Finished Thickness cannot be empty!', trigger: 'change' }
    ],
    copper_weight: [
      { required: true, message: 'Copper weight cannot be empty!', trigger: 'change' }
    ]
  }
}
export default PcbSpecValidations
